import {
    instance as axios,
    setJwtToken,
  } from "../../config/axiosInstance";
  
export const complementaryFeedingListApi = async (data) => {
  const endPoint = `admin/complementary-feeding/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
